module.exports = __webpack_public_path__ + "static/img/logo.3544a11c.png";